(() => {
  const normalise = (value) => window.BbZapiet.normalise(value);

  function matchingLocation(locations, title, id) {
    const matches = locations.filter((location) => id
      ? String(location.id) === String(id)
      : normalise(location.company_name) === normalise(title));
    return matches.length === 1 ? matches[0] : null;
  }

  function coordinates(location) {
    const latitude = Number(location?.latitude);
    const longitude = Number(location?.longitude);
    return Number.isFinite(latitude) && Number.isFinite(longitude) && latitude !== 0 && longitude !== 0
      ? { latitude, longitude } : null;
  }

  function distance(a, b) {
    const radians = (degrees) => degrees * Math.PI / 180;
    const latitude = radians(b.latitude - a.latitude);
    const longitude = radians(b.longitude - a.longitude);
    const angle = Math.sin(latitude / 2) ** 2
      + Math.cos(radians(a.latitude)) * Math.cos(radians(b.latitude)) * Math.sin(longitude / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(angle), Math.sqrt(1 - angle));
  }

  async function canOrder(shop, candidate) {
    const product = {
      product_id: Number(candidate.row.dataset.productId),
      variant_id: Number(candidate.row.dataset.variantId),
      quantity: 1,
    };
    try {
      // We only need proof of one bookable day; fetching the full schedule here
      // delays the fallback and adds unnecessary Zapiet time-slot requests.
      return Boolean(await window.BbZapiet.firstPickupDay(shop, candidate.location.id, [product]));
    } catch (_error) {
      return false;
    }
  }

  async function resolveCandidates(shop, rows) {
    const resolved = [];
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(4, rows.length) }, async () => {
      while (next < rows.length) {
        const row = rows[next++];
        const product = { product_id: Number(row.dataset.productId), variant_id: Number(row.dataset.variantId), quantity: 1 };
        try {
          const locations = await window.BbZapiet.locationsFor(shop, product);
          const location = matchingLocation(locations, row.dataset.name, row.dataset.zapietId);
          if (coordinates(location)) resolved.push({ row, location });
        } catch (_error) {}
      }
    }));
    return resolved;
  }

  async function update(section) {
    if (section.dataset.bbAlternativesReady === 'true') return;
    section.dataset.bbAlternativesReady = 'true';
    const rows = [...section.querySelectorAll('[data-bb-alternative]')];
    const result = section.querySelector('[data-bb-alternative-result]');
    const shop = section.dataset.zapietShop;
    if (!shop || !rows.length || !result || !window.BbZapiet) return;

    try {
      const originProduct = { product_id: Number(section.dataset.zapietOriginProduct), variant_id: Number(section.dataset.zapietOriginVariant), quantity: 1 };
      if (!originProduct.product_id || !originProduct.variant_id) return;
      const originLocations = await window.BbZapiet.locationsFor(shop, originProduct);
      const origin = matchingLocation(originLocations, section.dataset.zapietCollection, section.dataset.zapietLocationId);
      const originPosition = coordinates(origin);
      if (!originPosition) return;

      const candidates = (await resolveCandidates(shop, rows))
        .map((candidate) => ({ ...candidate, distance: distance(originPosition, coordinates(candidate.location)) }))
        .sort((a, b) => a.distance - b.distance).slice(0, 8);

      for (const candidate of candidates) {
        if (!await canOrder(shop, candidate)) continue;
        result.querySelector('[data-bb-alternative-name]').textContent = candidate.row.dataset.name;
        result.querySelector('[data-bb-alternative-detail]').textContent =
          `Ongeveer ${Math.max(1, Math.round(candidate.distance))} km hemelsbreed vanaf deze locatie. Ophaaldagen kies je in de winkelwagen.`;
        result.querySelector('[data-bb-alternative-link]').href = candidate.row.dataset.url;
        result.hidden = false;
        section.querySelector('.bb-pickup__button').classList.add('bb-pickup__button--secondary');
        return;
      }
    } catch (_error) {
      return;
    }
  }

  document.querySelectorAll('.bb-pickup[data-zapiet-shop]').forEach(update);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.bb-pickup[data-zapiet-shop]').forEach(update);
  });
})();
